import { LegacyText, styled } from '@gogame/components';

export const LinkText = styled(LegacyText)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;
